//Author June Leow
//Date Mar 21th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, deleteAPICallGenerator, callBackGenerator, confirmation, formatDateTime} from '../../../util/util';
import React, {useReducer, useEffect} from 'react';
import {Col, Row, Nav, NavItem} from 'reactstrap';
import {Link, NavLink, useParams} from 'react-router-dom';
//initialize the state
const initialState = {
  pdfReports:[],
};

//reducer function that perform state update
const reducer = getReducer();


const UniformPropertyDatasetPDF  = (props)=>{
  const controller = new AbortController();
  let { updFk} = useParams();
  let newInitialState = Object.assign({}, initialState, {updFk:updFk});
  const [state, dispatch] = useReducer(reducer,newInitialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    getUPDReport();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const removeFileFromList = (ID)=>{
    let pdfReports = state.pdfReports.slice();

    for(let i=0;i<pdfReports.length;i++){
      if(pdfReports[i].ID===ID){
        pdfReports.splice(i, 1);
        break;
      }
    }

    setState({pdfReports:pdfReports});
  }

  //API call
  //delete file
  const deleteFile = (ID) => {
    let callBack = (response)=>{
      let code = response.data?response.data.code:undefined;
      if(code==='00'){
        removeFileFromList(ID);
      }
    };
    httpDelete('uniformPropertyDataset/pdf/'+ID, '', 'Oops, something went wrong and could not delete the file, please try again later.', callBack);
  }

  const getUPDReport = () => {
    let callBack = apiCallBack([{state:'pdfReports', key:'data'}]);
    httpGet('uniformPropertyDataset/pdf/'+state.updFk, '', 'Oops, something went wrong and could not load report for this UDP. Please try again later.', callBack);
  }

  //render
  return <div>
    <div>
      <Row>
        <Col sm="6">
          <NavLink to="/uniform-property-dataset">Back to UPD Pipeline</NavLink>
        </Col>
        <Col sm="6" className="align-right">
        </Col>
      </Row>
    </div>
    <Nav tabs>
      <NavItem>
        <NavLink className="nav-link" to={"/uniform-property-dataset/"+state.updFk}>UPD (Uniform Property Dataset Report)</NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to={"/uniform-property-dataset/post-completion-report/"+state.updFk}>PCR (Post Completion Report)</NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link active" to="#">Generated Report</NavLink>
      </NavItem>
      <NavItem>
        <a className="nav-link" href="https://www.smartdraw.com/" target="_blank" rel="noopener noreferrer">Floor Plan - Smart Draw</a>
      </NavItem>
      <NavItem>
        <a className="nav-link" href="https://www.cubi.casa/" target="_blank" rel="noopener noreferrer">Floor Plan - Cubi Casa</a>
      </NavItem>
    </Nav>
    {
      state.pdfReports.map(
        (pdf, index)=>{
          return (
            <div key={index} className="file-container">
                <div className="font-bold">
                <div className="cursor-pointer display-inline link-color"><i className="fa fa-trash red-color" onClick={
                  ()=>{
                    confirmation(
                      ()=>{deleteFile(pdf.ID)},
                      ()=>{},
                      'Delete file?',
                      'Are you sure you want to delete this file?');
                  }
                }></i>&nbsp;<b><a href={pdf.presign_url} target="_blank">{pdf.name}</a></b>
                <br/>
                <i>{formatDateTime(pdf.datetime_created)}</i>
              </div>
              </div>
            </div>
          )
        }
      )
    }
  </div>
}

export default UniformPropertyDatasetPDF;